import React from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Pill from "../../shared/helpers/Pill.js";
import { formatDateReadable } from "../../utilities/helpers.js";
import { getInitials } from "../../utilities/helpers.js";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import DefaultAvailabilityRequestCard from "./DefaultAvailabilityRequestCard.js";
import EmptyState from "../../shared/helpers/EmptyState.js";
import AvatarSmall from "../../shared/helpers/AvatarSmall.js";
import AvailabilityApprovedDrawer from "./AvailabilityApprovedDrawer.js";

export default function AvailabilityApprovedTable(props) {
  // New state for drawer
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [selectedRequest, setSelectedRequest] = React.useState(null);

  const handleRowClick = (availability) => {
    // Format the request info to match what the drawer expects
    const requestInfo = {
      name: availability.name,
      day: availability.day,
      currentAvailability: availability.availability,
      currentAvailability2: availability.availability2,
      currentPreferences: availability.preferences,
      requestedAvailability: availability.requested.availability,
      requestedAvailability2: availability.requested.availability2,
      requestedPreferences: availability.requested.preferences,
      inEffect: availability.requested.inEffect,
      note: availability.requested.note,
      managerNote: availability.requested.acting_manager_note,
      dateSubmitted: availability.created_at,
      dateResponded: availability.acting_manager_response_at,
      actedBy: availability.acting_manager_name,
      status: availability.requested.status
    };
    setSelectedRequest(requestInfo);
    setDrawerOpen(true);
  };


  return (
    <>
      <div className="mt-12">
        {props.availabilityHistoryData?.length > 0 ? (
          <div>
            <div className="flex items-center px-6">
              <div className="flex-auto">
                <h1 className="text-xl font-bold text-slate-900">History</h1>
              </div>
            </div>
            <div className="mt-8 flex flex-col">
              <div className="-my-2 overflow-x-auto min-w-full">
                <div className="inline-block min-w-full py-2 align-middle">
                  <div className="overflow-hidden">
                    <table className="min-w-full divide-y divide-slate-100">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="w-[24%] py-3 pl-6 pr-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Employee
                          </th>
                          <th
                            scope="col"
                            className="w-[18%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Day
                          </th>
                          <th
                            scope="col"
                            className="w-[17%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Existing Availability
                          </th>
                          <th
                            scope="col"
                            className="w-[17%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Requested Availability
                          </th>
                          <th
                            scope="col"
                            className="w-[20%] px-3 py-3 text-left text-xs font-semibold text-slate-500"
                          >
                            Effective Date
                          </th>
                          <th
                            scope="col"
                            className="w-[20%] px-3 py-3"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 bg-white">
                        {props.availabilityHistoryData?.map((availability, i) => (
                          <tr
                            key={i}
                            className="hover:bg-slate-50 cursor-pointer transition-colors"
                            onClick={() => handleRowClick(availability)}
                          >
                            <td className="whitespace-nowrap py-3.5 pl-6 pr-3 text-sm">
                              <div className="flex items-center">
                                <AvatarSmall
                                  initials={getInitials(availability.name)}
                                />
                                <div className="ml-2">
                                  <div className="font-semibold text-slate-900">
                                    {availability.name}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-900">
                              <div>{availability.day}</div>
                            </td>
                            <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-900">
                              <DefaultAvailabilityRequestCard
                                day={availability.day}
                                availability={availability.availability}
                                availability2={availability.availability2}
                                preferences={availability.preferences}
                                status="current"
                              />
                            </td>
                            <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-900">
                              <DefaultAvailabilityRequestCard
                                day={availability.day}
                                availability={availability.requested.availability}
                                availability2={
                                  availability.requested.availability2
                                }
                                preferences={availability.requested.preferences}
                                status={availability.requested.status.toLowerCase()}
                              />
                            </td>
                            <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
                              {availability.requested.inEffect
                                ? formatDateReadable(availability.requested.inEffect)
                                : "None"}
                            </td>
                            <td className="whitespace-nowrap pl-3 pr-3 py-3.5 text-sm text-right">
                              <div className="flex items-center justify-end space-x-3">
                                {availability.requested.note && (
                                  <Tooltip title={availability.requested.note}>
                                    <span className="text-slate-400 cursor-pointer">
                                      <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
                                    </span>
                                  </Tooltip>
                                )}
                                {availability.requested.acting_manager_note && (
                                  <Tooltip title={availability.requested.acting_manager_note}>
                                    <span className="text-violet-600 cursor-pointer">
                                      <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
                                    </span>
                                  </Tooltip>
                                )}
                                <Pill
                                  status={availability.requested.status.toLowerCase()}
                                />
                                <Tooltip title="Archive">
                                  <IconButton
                                    className="text-slate-400"
                                    sx={{ backgroundColor: "#f8fafc", "&:hover": { backgroundColor: "#f1f5f9" } }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.archive_availability_request(
                                        availability.requested.id
                                      );
                                    }}
                                  >
                                    <ArchiveOutlinedIcon sx={{ fontSize: 18 }} />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="border-b border-slate-100"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <EmptyState
            title="History"
            description="No acted on availability at the moment"
          />
        )}
      </div>
      {selectedRequest && (
        <AvailabilityApprovedDrawer
          isDrawerOpen={isDrawerOpen}
          setDrawerOpen={setDrawerOpen}
          requestInfo={selectedRequest}
          storeTimezone={props.storeTimezone}
        />
      )}
    </>
  );
}
